export const DETAILS_BOX_HEIGHT = 286;
export const DETAILS_BOX_COLUMN_GAP = 24;
export const DETAILS_IMAGE_WIDTH = 224;
export const DETAILS_IMAGE_HEIGHT = 278;
export const DETAILS_IMAGE_BLOCK_HEIGHT = 230;
export const DETAILS_PAGER_ROW_HEIGHT = 48;
export const DETAILS_STATUS_WIDTH = 240;
export const DETAILS_STATUS_PILL_WIDTH = 230;
export const DETAILS_STATUS_PILL_HEIGHT = 36;
export const DETAILS_STATUS_PILL_RADIUS = 18;
export const DETAILS_STATUS_PILL_GAP = 10;
export const DETAILS_STATUS_FONT_SIZE = 14;
export const MODERATION_ROW_HEIGHT = 34;
export const MODERATION_ROW_PADDING = 10;
export const MODERATION_ROW_FONT_SIZE = 13;
export const MODERATION_ROW_RADIUS_CSS = "8px";
export const MODERATION_ROW_GAP = 8;
